import React from 'react';
import { Label, Root } from '../form/formik/input/input.styles';
import { ELabelPos } from 'components/form/formik/types';

const LabelWrapper: React.FC<{ label?: string; labelPos?: ELabelPos }> = ({
    labelPos,
    label,
    children,
}) => {
    return (
        <Root labelPos={labelPos}>
            {label ? <Label date-id={'label'}>{label}</Label> : null}
            {children}
        </Root>
    );
};

export default LabelWrapper;
